import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=b780e162&scoped=true&"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordForm.vue?vue&type=style&index=0&id=b780e162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b780e162",
  null
  
)

export default component.exports